export default "__VITE_ASSET__FYECXnIS__"